export { default as HTML5 } from "./html5.png";
export { default as CSS3 } from "./css3.png";
export { default as JavaScript } from "./javascript.png";
export { default as NodeJS } from "./nodejs.png";
export { default as Vue } from "./vue.png";
export { default as React } from "./react.png";
export { default as Firebase } from "./firebase.png";
export { default as Git } from "./git.png";
export { default as Sass } from "./sass.png";
export { default as MongoDB } from "./mongodb.png";
export { default as Mocha } from "./mocha.jpg";
export { default as Chai } from "./chai.png";
export { default as jQuery } from "./jquery.png";
export { default as Express } from "./Expressjs.png";
export { default as Postgree } from "./postgree.png";
export { default as Vuetify } from "./vuetify.png";
export { default as Bootstrap } from "./bootstrap.png";
export { default as Webpack } from "./webpack.png";



// WEBPACK FOOTER //
// ./src/assets/img/skills/index.js